export const FORM_NAME = 'change-password';



// WEBPACK FOOTER //
// ./src/change-password/constants.js